<template>
  <div>
    <helper-layout :loaded="mx_loaded">
      <material-table
        ref="listTable"
        :headers="headers"
        :items="shipListData.items"
        :paginate="paginateConfig"
        :search-data="searchData"
        :hide-no-data-text="true"
        :total-count="shipListData.totalCount"
        @pageChange="handlePageChange"
        @searchChange="handleSearchChange"
      >
        <!-- 表格顶部工具栏 -->
        <template v-slot:toolbar>
          <v-layout justify-end class="toolbar">
            <v-flex shrink>
              <!-- 批量导入 -->
              <v-btn
                v-if="getPermission('OrderManager.ShipmentList.ShipAndEditShip')"
                hollow
                color="success"
                @click="handleImport"
              >
                {{ $t("Views.Customer.shipmentBatchImport") }}
              </v-btn>
            </v-flex>
          </v-layout>
        </template>
        <template slot="noDataText">
          <div>
            <div>{{ $t('Views.Setting.statusNoData') }}</div>
            <div>{{ $t('Views.Setting.noStatus',{'0':getStatusText(form.status)}) }}</div>
          </div>
        </template>
      </material-table>
    </helper-layout>

  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { pageLoadMx } from '@/plugins/mixins.js'
import ENUMS from '@/dict/enums.js'
const statusMap = {
  ToBeShip: { color: '#FF0000' },
  Cancel: { color: '#999999' },
  Shipped: { color: '' }
}
// const currentDate = format(new Date(), 'YYYY-MM-DD')
export default {
  components: {
  },
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      valid: false,
      // 物流公司单号数组
      paginateConfig: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      form: {
        sorting: '',
        skipCount: 0,
        maxResultCount: 10,
        shipTime: '',
        status: 'ToBeShip'
      },
      headers: [
        {
          text: $t('Views.Order.outstock_label'),
          value: 'stockNumber',
          width: 130
        },
        {
          text: $t('Views.Order.order_number_label'), // '关联订单号',
          value: 'orderNumber',
          width: 130
        },
        // {
        //   // 收货人 收货人弥生编号
        //   align: 'left',
        //   renderHeader: (h, params) => {
        //     return h(
        //       'div',
        //       {
        //         domProps: {
        //           innerHTML: $t('Views.Order.receiver') + '<br/>' + $t('Views.Order.receiveNum')
        //         }
        //       }
        //     )
        //   },
        //   render: (h, param) => {
        //     const text = param.row.receiverName + (param.row.receiverCode ? '<br />' + param.row.receiverCode : '<br />' + '--')
        //     return h('div', {
        //       domProps: {
        //         innerHTML: text
        //       }
        //     })
        //   },
        //   width: 180
        // },
        {
          text: $t('Views.Order.customer_info_label'),
          value: 'customerInfo',
          width: 130,
          align: 'left',
          renderHeader: (h, params) => {
            return h(
              'div',
              {
                domProps: {
                  innerHTML: $t('Views.Order.receiver') + '<br/>' + $t('Views.Order.receiveCodeNum')
                }
              }
            )
          },
          render: (h, param) => {
            const text = param.row.receiverName + (param.row.receiverNewCode && param.row.receiverCode ? '<br />' + param.row.receiverNewCode
              : param.row.receiverNewCode ? '<br />' + param.row.receiverNewCode : '<br />' + param.row.receiverCode)
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          text: $t('Views.Finance.sales'), value: 'saleName', width: 120
        },
        {
          text: $t('Views.Order.shipmentDate'), // 出货日,
          value: 'shipTime',
          type: 'date'
        },
        {
          text: $t('Views.Order.ship_time_label'), // 出货日,
          value: 'shippedTime',
          type: 'date'
        },
        {
          text: $t('Views.Order.ship_status_label'), // '发货状态',
          value: 'status',
          type: 'status',
          render: (h, params) =>
            h(
              'div',
              {
                style: {
                  color: statusMap[params.row.status].color
                },
                class: 'status'
              },
              ENUMS.ShipStatus[params.row.status]
            )
        },
        {
          text: $t('Views.Order.action_label'), // '操作',
          value: 'action',
          actions: [
            {
              text: $t('Views.Order.check_label'), // '查看',
              color: 'success',
              visible: (row) => {
                return row.row.status === 'Shipped'
              },
              actionFn: row => {
                this.$router.push({
                  name: 'shipmentDetail',
                  query: { id: row.row.id }
                })
              }
            },
            {
              text: $t('Views.Order.ship_label'), // '发货',
              color: this.$store.state.app.payBtnColor,
              visible: row =>
                this.getPermission(
                  'OrderManager.ShipmentList.ShipAndEditShip'
                ) && row.row.status === 'ToBeShip',
              actionFn: row => {
                this.$router.push({
                  name: `shipmentDeliver`,
                  query: {
                    id: row.row.id
                  }
                })
              }
            },
            {
              text: $t('Views.Order.change_ship_label'), // '修改发货信息',
              color: this.$store.state.app.editBtnColor,
              visible: row =>
                this.getPermission(
                  'OrderManager.ShipmentList.ShipAndEditShip'
                ) && row.row.status === 'Shipped',
              actionFn: row => {
                this.$router.push({
                  name: `shipmentDeliver`,
                  query: {
                    id: row.row.id,
                    logisticsId: row.row.logisticsId,
                    isEdit: true
                  }
                })
              }
            }
          ]
        }
      ],
      searchData: [
        {
          key: 'filter',
          value: '',
          label: $t('Views.Order.customer_info_label'),
          placeholder: $t('Views.Order.search_placeholder_label')
        },
        {
          key: 'salesId',
          type: 'select',
          name: $t('Views.Order.sale_label'),
          placeholder: $t('Core.System.pleaseSelect'),
          itemText: 'name',
          itemValue: 'id',
          state: [],
          value: ''
        },
        {
          key: 'orderNumber',
          value: '',
          label: $t('Views.Order.orderNum'),
          placeholder: $t('Views.Order.selectOrderNum')
        },
        {
          key: 'daterange',
          type: 'daterange',
          icon: 'mdi-calendar-range',
          displayFormat: 'YYYY-MM-DD HH:mm',
          label: $t('Views.Order.order_time_label'),
          value: {}
        },
        {
          key: 'productName',
          label: $t('Views.Order.goodsInfo'),
          placeholder: $t('Views.Order.search_goods_label'),
          value: ''
        },
        {
          key: 'status',
          value: 'ToBeShip',
          label: $t('Views.Order.ship_status_label'),
          placeholder: $t('Views.Order.allItem'),
          type: 'select',
          state: [
            {
              value: 'ToBeShip', // '待发货'
              label: $t('Views.Order.ToBeShip')
            },
            {
              value: 'Shipped', // '已发货'
              label: $t('Views.Order.Shipped')
            },
            {
              value: 'Cancel', // '已取消'
              label: $t('Views.Order.Cancel')
            }
          ]
        }, {
          key: 'shipTime',
          type: 'date',
          icon: 'mdi-calendar-range',
          displayFormat: 'YYYY-MM-DD',
          label: $t('Views.Order.shipmentDate'),
          value: ''
        },
        {
          key: 'shippedTime',
          type: 'date',
          icon: 'mdi-calendar-range',
          displayFormat: 'YYYY-MM-DD',
          label: $t('Views.Order.ship_time_label'),
          value: ''
        }
      ],
      /** 是否是编辑发货信息，false为编辑，true为新增 */
      isEdit: false
    }
  },
  computed: {
    color() {
      return this.$store.state.app.color
    },
    ...mapState('order', ['shipListData', 'shipmentSearch']),
    ...mapState('setting', ['staffAllData'])
  },
  mounted() {
    if (this.$route.query.status) {
      this.searchData[5].value = this.$route.query.status
      this.form.status = this.$route.query.status
    } else {
      // 读取store里面的搜索条件
      if (this.shipmentSearch && this.shipmentSearch.searchData && this.form) {
        this.searchData = JSON.parse(this.shipmentSearch.searchData)
        this.form = JSON.parse(this.shipmentSearch.form)
        this.form.skipCount = 0
        this.form.maxResultCount = 10
      }
    }
    this.getPage()
    this.getStaff()
  },
  methods: {
    ...mapActions('order', [
      'getShipList',
      'handleCheckMergeShip',
      'handleShip',
      'handleMergeShip',
      'handleShipInfo',
      'handleModifyShipInfo',
      'saveShipmentSearch'
    ]),
    ...mapActions('setting', ['getStaffAllData']),
    // 保存搜索条件
    saveSearchData() {
      this.saveShipmentSearch({
        searchData: JSON.stringify(this.searchData),
        form: JSON.stringify(this.form)
      })
    },
    handleImport() {
      this.$router.push({
        name: 'importShipment'
      })
    },
    getStatusText(status) {
      return ENUMS.ShipStatus[status] || this.$t('Views.Finance.all')
    },
    /** 搜索数据表单变化 */
    handleSearchChange(search) {
      this.form = { ...this.form, ...search }
      if (search.daterange) {
        this.form = {
          ...this.form,
          ...{ orderStartTime: search.daterange.start },
          ...{ orderEndTime: search.daterange.end }
          // ...{ shipTime: search.shipTime }
        }
      }
      delete this.form.daterange
      // 保存搜索条件
      this.saveSearchData()
      this.getPage(1)
    },
    getPage(page) {
      if (typeof page !== 'undefined') {
        this.paginateConfig.page = page
        this.form.skipCount = (page - 1) * this.form.maxResultCount
      }

      if (!this.mx_loaded) this.mx_loading_fn() // 页面加载中
      this.getShipList(this.form).then(() => {
        this.paginateConfig.total = this.shipListData.totalCount
        this.mx_loaded_fn() // 页面加载完成
      })
    },
    handlePageChange(page) {
      this.getPage(page)
    },
    /** 获取是否有权限 */
    getPermission(name) {
      return this.$util.tool.hasPerm(name)
    },

    getStaff() {
      this.getStaffAllData({ isActive: true, permissionCheck: true }).then(
        () => {
          this.searchData[1].state = this.staffAllData.items
        }
      )
    }
  }
}
</script>
<style scoped>
.require-mark::before {
  content: "*";
  color: red;
  font-size: 18px;
  font-weight: bold;
}
.operation-bar {
  display: flex;
  height: 50px;
  align-items: center;
  padding-top: 30px;
}
.all {
  margin-left: 0px;
}
.selected {
  font-size: 14px;
}
.dialog-title {
  font-size: 14px;
  color: #515151;
  letter-spacing: 0;
  font-weight: bold;
}
.dialog-fix-input {
  margin-top: -15px;
}
.dialog-fix-require {
  margin-left: -10px;
}
.dialog-fix-container {
  margin: -20px 2px 0 2px;
}
.fix-bottom-mb10 {
  margin-bottom: 10px;
}
</style>
